import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  phones: [],
  allPhones: [],
  totalPages: 0,
  totalRecords: 0,
  phone: null,
  errorStatus: null,
  readyPhones: [],
  topNearestPhones: [],
  readyPhonesByStation: [],
  phonesActivityReportList: [],
  phoneUsersActivityReportList: [],
};
const getters = {
  getApiLoad_76: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Phones(state, phones) {
    state.phones = phones.items;
    state.totalPages = phones.totalPages;
    state.totalRecords = phones?.totalRecords ?? 0;
  },
  SET_AllPhones(state, phones) {
    state.allPhones = phones;
  },
  SET_Phone(state, phone) {
    state.phone = phone;
  },
  SET_ReadyPhones(state, phone) {
    state.readyPhones = phone;
  },
  SET_TopNearestPhones(state, phone) {
    state.topNearestPhones = phone;
  },
  SET_ReadyByStationPhones(state, phone) {
    state.readyPhonesByStation = phone;
  },
  SET_PhonesActivityReport(state, data) {
    state.phonesActivityReportList = data;
  },
  SET_PhonesUsersActivityReport(state, data) {
    state.phoneUsersActivityReportList = data;
  },
};
const actions = {
  errorPhone({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllPhones({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Phones/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllPhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getPhonesWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, code, isActive, phoneToken, iPAddress, useAPN, isBroken },
  ) {
    var url = '/Phones/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (code) {
      url += '&Code=' + code;
    }
    if (isActive != null && isActive != undefined) {
      url += '&IsActive=' + isActive;
    }
    if (phoneToken) {
      url += '&PhoneToken=' + phoneToken;
    }
    if (iPAddress) {
      url += '&IPAddress=' + iPAddress;
    }
    if (useAPN != null && useAPN != undefined) {
      url += '&UseAPN=' + useAPN;
    }
    if (isBroken != null && isBroken != undefined) {
      url += '&IsBroken=' + isBroken;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Phones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  addPhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Phones', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getPhone({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Phones/ById?phoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Phone', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  editPhone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Phones/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  deletePhone({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Phones/Remove?phoneId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  activatePhoneDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post(
        '/Phones/Activate',
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf }, params },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  deactivatePhoneDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .post(
        '/Phones/Deactivate',
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf }, params },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getListOfReadyPhone({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Phones/Ready', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ReadyPhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getListOfTopNearestPhone({ commit, dispatch, rootState }, { lat, lng }) {
    return apiClient
      .get('/Phones/TopNearest?Latitude=' + lat + '&Longitude=' + lng, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TopNearestPhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getListOfReadyPhoneByStation({ commit, dispatch, rootState }, stationId) {
    return apiClient
      .get('/Phones/ReadyByStation?subStationId=' + stationId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ReadyByStationPhones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getPhonesActivityReport({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Phones/ActivityReport', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PhonesActivityReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  getUsersActivityReport({ commit, dispatch, rootState }, phoneActivityId) {
    return apiClient
      .get('/Phones/ActivityUsers?phoneActivityId=' + phoneActivityId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PhonesUsersActivityReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
  positionRequest({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Phones/LocationNotification?phoneId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorPhone', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
